import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import colors from "../../../../../../config/colors";
import {
  ProgramsListItemContainer,
  ItemSection,
  ProgramImage,
  ProgramName,
  GrabHandle,
  ItemNumber,
} from "./styles";
import Modal from "../../../../../../common/Modal";
import Subscription from "../../../ProgramContent/ProgramHome/Subscription";
import PaymentProcess from "../../../ProgramContent/ProgramHome/PaymentProcess";
import { getUserInfo } from "../../../../../../Store/User/accessors";
import { Context } from "../../../../../../Store";
import AccessBlockModal from "./AccessBlockModal";

function ProgramsListItem({
  program,
  setHamburgerOpen,
  hamburgerOpen,
  closeOnClick,
  getPrograms,
}) {
  let { selectedProgram } = useParams();
  let navigate = useNavigate();

  let isActive = selectedProgram == program.id;

  // Add the Payment Modal Details Here
  const { state, dispatch } = React.useContext(Context);

  const userData = getUserInfo(state);

  const [isPremiumOpen, setIsPremiumOpen] = useState(false);
  const [IsPaymentOpen, setIsPaymentOpen] = useState(false);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [isNotActive, setIsNotActive] = useState(false);

  const [plan, setPlan] = useState("");

  // console.log("User Data:", userData);
  // console.log("Program:", program);

  const viewProgramHandler = () => {
    if (
      program?.subscription?.programId &&
      (program?.programManager?.userId || program?.participant?.id)
    ) {
      navigate("/programs/" + program.id + "/home");
      if (closeOnClick) setHamburgerOpen(!hamburgerOpen);
    } else if (
      program?.userId === userData?.id &&
      (!program?.subscription || !program?.subscription?.programId)
    ) {
      setIsPremiumOpen(!isPremiumOpen);
    } else if (
      program?.userId !== userData?.id &&
      (!program?.subscription || !program?.subscription?.programId)
    ) {
      setShowAccessModal((prevState) => !prevState);
    } else if (program?.participant?.status !== "active") {
      setIsNotActive(true);
      setShowAccessModal((prevState) => !prevState);
    }
  };

  const closeAccessModalHandler = () => {
    setShowAccessModal(false);

    navigate("/");
  };

  // useEffect(() => {
  //   if (!program?.subscription) {
  //     navigate("/programs");
  //   }
  // }, [program]);
  // Add the Payment Modal Details Here

  return (
    <>
      <ProgramsListItemContainer
        isActive={isActive}
        onClick={viewProgramHandler}
        draggable={true}
        onDragStart={(e) => {
          e.dataTransfer.setData("text", program.id);
        }}
        title={program.title}
      >
        <ItemSection>
          <ProgramImage src={program.image} />
          <ProgramName>{program.title}</ProgramName>
        </ItemSection>
        {program?.newRequests && (
          <ItemNumber>{program?.newRequests}</ItemNumber>
        )}
        <GrabHandle>
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.41464 2.53125C4.67353 2.53125 4.88339 2.32138 4.88339 2.0625C4.88339 1.80362 4.67353 1.59375 4.41464 1.59375C4.15576 1.59375 3.94589 1.80362 3.94589 2.0625C3.94589 2.32138 4.15576 2.53125 4.41464 2.53125Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.41464 5.96875C4.67353 5.96875 4.88339 5.75888 4.88339 5.5C4.88339 5.24112 4.67353 5.03125 4.41464 5.03125C4.15576 5.03125 3.94589 5.24112 3.94589 5.5C3.94589 5.75888 4.15576 5.96875 4.41464 5.96875Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.41464 9.40625C4.67353 9.40625 4.88339 9.19638 4.88339 8.9375C4.88339 8.67862 4.67353 8.46875 4.41464 8.46875C4.15576 8.46875 3.94589 8.67862 3.94589 8.9375C3.94589 9.19638 4.15576 9.40625 4.41464 9.40625Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.53696 2.53125C7.79584 2.53125 8.00571 2.32138 8.00571 2.0625C8.00571 1.80362 7.79584 1.59375 7.53696 1.59375C7.27807 1.59375 7.06821 1.80362 7.06821 2.0625C7.06821 2.32138 7.27807 2.53125 7.53696 2.53125Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.53696 5.96875C7.79584 5.96875 8.00571 5.75888 8.00571 5.5C8.00571 5.24112 7.79584 5.03125 7.53696 5.03125C7.27807 5.03125 7.06821 5.24112 7.06821 5.5C7.06821 5.75888 7.27807 5.96875 7.53696 5.96875Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.53696 9.40625C7.79584 9.40625 8.00571 9.19638 8.00571 8.9375C8.00571 8.67862 7.79584 8.46875 7.53696 8.46875C7.27807 8.46875 7.06821 8.67862 7.06821 8.9375C7.06821 9.19638 7.27807 9.40625 7.53696 9.40625Z"
              stroke={isActive ? colors.background : colors.primary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </GrabHandle>
      </ProgramsListItemContainer>

      {/* New Start  */}
      {isPremiumOpen && (
        <Modal
          onClose={() => setIsPremiumOpen(false)}
          minWidth={"50vw"}
          isButtonCenter={true}
          isNotRound={true}
          hideBorder={true}
          isMain={true}
          isTask={true}
          actions={[
            {
              text: "Cancel",
              onClick: () => {
                setIsPremiumOpen(false);
              },
            },
          ]}
        >
          <Subscription
            setIsPremiumOpen={setIsPremiumOpen}
            setIsPaymentOpen={setIsPaymentOpen}
            setPlan={setPlan}
            getPrograms={getPrograms}
            program={program}
          />
        </Modal>
      )}
      {IsPaymentOpen && (
        <Modal
          onClose={() => setIsPaymentOpen(false)}
          minWidth={"50vw"}
          isMain={true}
          isButtonCenter={true}
          hideBorder={true}
          isNotRound={true}
          isTask={true}
        >
          <PaymentProcess plan={plan} program={program} />
        </Modal>
      )}

      {showAccessModal && (
        <Modal
          onClose={closeAccessModalHandler}
          maxWidth={"25%"}
          minWidth={"25vw"}
          isMain={true}
          isButtonCenter={true}
          hideBorder={true}
          isNotRound={true}
          isTask={true}
          isHideIcon={true}
          actions={[
            {
              text: "Close",
              onClick: closeAccessModalHandler,
              textColor: true,
              isNotRound: "5px",
            },
          ]}
        >
          <AccessBlockModal
            text={
              isNotActive
                ? "Your access to this program has been deactivated. Please contact your manager to regain access"
                : "Access to the program is temporarily unavailable. Please wait while your manager completes the subscription. Thank you for your patience."
            }
          />
        </Modal>
      )}
      {/* New Start End */}
    </>
  );
}
export default ProgramsListItem;
